import React, { useEffect, useState } from "react";
import { IoMdCloseCircle } from "react-icons/io";
import { useStateContext } from "../../../../../contexts/ThemeContext";
import { ReactComponent as TrashIconDark } from "../../../../../assets/dashboard/link/trashIcon-dark.svg";
import { ReactComponent as TrashIcon } from "../../../../../assets/dashboard/link/trashIcon.svg";
import { ReactComponent as ImagePlacholder } from "../../../../../assets/dashboard/avatar/gallery.svg";
import { ReactComponent as ImagePlacholderDark } from "../../../../../assets/dashboard/avatar/gallery-dark.svg";

import { reset } from "../../../../../redux/slices/imageGrid/ImageGridSlice";
import { toast } from "react-hot-toast";
import { FileUploader } from "react-drag-drop-files";
import ExtraSmallFilledButton from "../../../../../components/common/buttons/ExtraSmallFilledButton";
import useLocales from "../../../../../hooks/useLocales";
import { I18nextProvider } from "react-i18next";
import i18nForComponent from "../../../../../locales/component/i18nForComponent";
import { useSelector } from "react-redux";

// This Form component is responsible for edit ImageGrid Block

const fileTypes = ["png", "jpg", "jpeg", "gif", "ico"];

const ImageGridForm = ({
  formType,
  handleDelete,
  submitHandlerParent,
  isLoading,
  preHeaderData,
}) => {
  const { darkMode } = useSelector((state) => state.theme);
  const { allLangs, tComponent, handleLanguageChange } = useLocales();
  const { setActiveMainPageNav } = useStateContext();
  const [files, setFiles] = useState([]);

  const [selectedReporterType, setSelectedReporterType] = useState("English");
  const [selectedLang, setSelectedLang] = useState("en");

  const [preViewImage, setPreViewImage] = useState([]);
  const baseUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    setActiveMainPageNav(true);

    return () => {
      setActiveMainPageNav(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (file) => {
    setFiles((prevFiles) => {
      const prevLength = prevFiles?.length;
      const newLength = file?.length;
      const preViewImages = preViewImage?.length;
      if (prevLength + newLength + preViewImages <= 4) {
        return [...prevFiles, ...file];
      } else {
        let newArray = [...file];
        newArray = newArray.splice(0, 4 - prevLength);
        return [...prevFiles, ...newArray];
      }
    });
    const files = [...file];
    files.map((item) => {
      const newItem = URL.createObjectURL(item);
      setPreViewImage((prevFiles) => {
        const prevLength = prevFiles?.length;
        const newLength = file?.length;
        if (prevLength + newLength <= 4) {
          return [...prevFiles, newItem];
        } else {
          let newArray = [newItem];
          newArray = newArray.splice(0, 4 - prevLength);
          return [...prevFiles, ...newArray];
        }
      });
      return null;
    });
  };

  const removeImage = (file) => {
    setPreViewImage((prevsFiles) =>
      prevsFiles.filter((item) => {
        return item !== file;
      })
    );

    setFiles((prevsFiles) =>
      prevsFiles.filter((item) => {
        return item !== file;
      })
    );
  };

  const handleSubmit = async () => {
    if (!preViewImage.length && files.length < 1) {
      toast.error("Please select Images");
      return;
    }
    const Images = [...files];
    const preViewImageUrl = preViewImage.map((item) => {
      const url = item.split("/");
      return (url.length > 5 && url[5]) || null;
    });

    const preViewImageName = preViewImageUrl.filter((item) => item != null);
    submitHandlerParent(Images, preViewImageName);
  };

  useEffect(() => {
    const headerValue =
      preHeaderData?.data?.coloum_value &&
      JSON.parse(preHeaderData?.data?.coloum_value);
    if (preHeaderData) {
      headerValue?.map((file) => {
        const newFile = baseUrl + "/profile/" + file;
        setPreViewImage((prevFiles) => {
          const prevLength = prevFiles?.length;
          const newLength = headerValue?.length;
          if (prevLength + newLength <= 4) {
            return [...prevFiles, newFile];
          } else {
            let newArray = [newFile];
            newArray = newArray.splice(0, 4 - prevLength);
            return [...prevFiles, ...newArray];
          }
        });
        return null;
      });
      setSelectedLang(preHeaderData?.data?.language);
      const matchedLang = allLangs?.find(
        (lang) => lang.value === preHeaderData?.data?.language
      );
      const shouldSetLang = matchedLang?.label;
      setSelectedReporterType(shouldSetLang);
      handleLanguageChange(preHeaderData?.data?.language);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preHeaderData]);

  const deleteHandler = async (data) => {
    if (formType === "add") {
      reset();
      setFiles([]);
    } else {
      handleDelete(data);
    }
  };

  return (
    <I18nextProvider i18n={i18nForComponent}>
      <>
        <div
          className="sm:mt-7 md:px-0 mt-10 mb-6 px-6"
          style={{
            direction: selectedLang === "ar" ? "rtl" : "ltr",
          }}
        >
          <div className="border rounded-lg bg-light_bg_v5 p-[25px] dark:bg-dark-secondary dark:border-color_dark">
            <div className="flex justify-between items-center  mb-[20px] sm:mb-[25px] ">
              <p className="text-small2_b sm:text-small1_bold text-heading_color dark:text-color_v1_dark uppercase">
                {formType === "edit" && tComponent(`imagegrid.${formType}`)}
                {formType === "add" && tComponent(`imagegrid.${formType}`)}
                &nbsp;
                {tComponent("imagegrid.image_grid")} &nbsp;
                <span className="text-small2 text-dark_bg_v5 dark:text-color_v1_dark">
                  ({tComponent("imagegrid.maximum")} 4)
                </span>
              </p>
              <div
                className={`w-[100px] bg-light_bg_v4 capitalize p-[10px] text-small2 lg:text-body_copy2 rounded-md flex justify-center items-center`}
              >
                {selectedReporterType ? selectedReporterType : "English"}
              </div>
            </div>
            {preViewImage.length < 4 && (
              <FileUploader
                handleChange={handleChange}
                name="file"
                types={fileTypes}
                maxSize={2}
                onSizeError={(errorMessage) => toast.error(errorMessage)}
                onTypeError={(errorMessage) => toast.error(errorMessage)}
                multiple={true}
                children={
                  <div>
                    <div className="flex items-center justify-center w-full">
                      <div className="flex flex-col items-center justify-center w-full py-[45px] px-3 md:px-5 border-2 border-dark_bg_v4 border-dashed rounded-lg cursor-pointer bg-light_bg_v5 dark:bg-dark-secondary hover:bg-gray-100 dark:border-color_dark dark:hover:border-gray-500 dark:hover:bg-gray-600">
                        <div className="flex flex-col items-center justify-center">
                          <div className="mb-[11px] h-[36px] w-[36]">
                            {darkMode ? (
                              <ImagePlacholderDark />
                            ) : (
                              <ImagePlacholder />
                            )}
                          </div>
                          <p className="text-small3 mb-[5px] lg:whitespace-nowrap text-center text-font_light_color dark:text-color_v1_dark">
                            {tComponent("imagegrid.drop_your_img")}, &nbsp;
                            <span className="text-small3_b text-main_color whitespace-nowrap">
                              {tComponent("imagegrid.browse_image")}
                            </span>
                          </p>
                          <p className="text-[10px] text-font_light_color tracking-[-0.3px] leading-[13px] dark:text-color_v2_dark">
                            2 MB {tComponent("imagegrid.maximum")}(.png, .gif,
                            .ico)
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              />
            )}
            {preViewImage.length > 0 && (
              <div className="flex mt-3 items-center gap-[14px] flex-wrap">
                {preViewImage.map((file, i) => {
                  return (
                    <div
                      key={i}
                      className="bg-light_bg_v4 rounded-lg cursor-pointer relative"
                    >
                      <div
                        onClick={() => removeImage(file)}
                        className="absolute cursor-pointer -right-2 -top-2 text-state_color_error text-lg"
                      >
                        <IoMdCloseCircle />
                      </div>
                      <img
                        className="h-[60px] w-[60px] sm:h-[64px] sm:w-[64px] p-1 object-cover rounded-lg"
                        src={file}
                        alt=""
                      />
                    </div>
                  );
                })}
              </div>
            )}
            <div className="flex mt-[26px] items-center justify-end">
              <button
                type="button"
                onClick={() => deleteHandler()}
                className="flex justify-center items-center"
              >
                {darkMode ? <TrashIconDark /> : <TrashIcon />}
                <p className="ps-1.5 pt-1 text-small3_b gray-700 text-heading_color dark:text-color_v1_dark">
                  {tComponent("imagegrid.delete_cap")}
                </p>
              </button>

              <ExtraSmallFilledButton
                name={tComponent("imagegrid.save_cap")}
                buttonType={"button"}
                isLoading={isLoading}
                onClickHandler={handleSubmit}
                classes={"ms-3"}
              />
            </div>
          </div>
        </div>
      </>
    </I18nextProvider>
  );
};

export default ImageGridForm;
